const downarrowIcon =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4qIHsgZmlsbDogIzM2YyB9PC9zdHlsZT4NCiAgICA8ZyBpZD0iZG93biI+DQogICAgICAgIDxwYXRoIGlkPSJhcnJvdyIgZD0iTTEgNGgxMEw2IDkgMSA0Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo=';

export default downarrowIcon;
